import { Injectable } from '@angular/core'
import { BrandOption } from '@app/models/brand-options'
import { CallSource } from '@app/models/call-source'
import { BrandService } from '@app/services/brand.service'
import { State, Action, StateContext, Selector } from '@ngxs/store'
import { tap } from 'rxjs/operators'
import { BrandAction } from './brand.actions'

// prettier-ignore
export interface BrandStateModel {
	brands: BrandOption[];
  callSources: CallSource[]
}

const defaults = {
	brands: [],
	callSources: [],
}

@State<BrandStateModel>({
	name: 'brand',
	defaults,
})
@Injectable()
export class BrandState {
	constructor(private readonly brandService: BrandService) {}

	@Action(BrandAction.LoadBrands)
	loadBrands({ patchState }: StateContext<BrandStateModel>) {
		return this.brandService.getAllBrands().pipe(tap((brands) => patchState({ brands })))
	}

	@Action(BrandAction.LoadCallSources)
	loadCallSources({ patchState }: StateContext<BrandStateModel>) {
		return this.brandService
			.getAllCallSources()
			.pipe(tap((callSources) => patchState({ callSources })))
	}

	@Selector()
	static allBrands(state: BrandStateModel) {
		return state.brands
	}

	@Selector()
	static callSources(state: BrandStateModel) {
		return state.callSources
	}
}
